//requestAnimationFrame polyfill
//https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
(function() {
    var lastTime = 0;
    var vendors = ['webkit', 'moz'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame =
          window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());


(function ($, window) {

    var WaypointInstance = function($items, settings) {
        var refreshPositions = true;
        function calculatePositions () {
            var windowTop = $(window).scrollTop(), windowBottom = windowTop + $(window).height();
            $items.each(function () {
                var $this = $(this), rect = this.getBoundingClientRect(),
                        height = rect.height ? rect.height : rect.bottom - rect.top,
                        visibleHeight = Math.min(height, $(window).height() - rect.top, height + rect.top, (rect.bottom < 0 ? 0 : height)),
                        pctVisible = Math.max(0, 100 * visibleHeight / height);
                        $this.data('waypointVisible', pctVisible);
                if ($this.data('waypointDelay') > 0) {
                    $this.data('waypointUpdate', false);
                    setTimeout($.proxy(function() {$(this).data('waypointUpdate', true);}, this), $this.data('waypointDelay'));
                } else {
                    $this.data('waypointUpdate', true);
                }
            });  
        }
        function enableRefresh()
        {
            refreshPositions = true;
        }
        function updateWaypointClasses() {
            if (refreshPositions) {
                calculatePositions();
                refreshPositions = false;
            }
            $items.each(function() {
                var $this = $(this);
                if ($this.data('waypointUpdate')) {
                    if ($this.data('waypointVisible') >= $this.data('waypoint')) {
                        if (!$this.hasClass(settings.appearClass)) {
                            $this.addClass(settings.appearClass);
                            $this.trigger('waypoint-appear');
                        }
                        if (!$this.hasClass(settings.visibleClass)) {
                            $this.addClass(settings.visibleClass);
                            $this.trigger('waypoint-show');
                        }
                    } else if ($this.hasClass(settings.visibleClass)) {
                        $this.removeClass(settings.visibleClass);
                        $this.trigger('waypoint-hide');
                    }
                }
            });
            requestAnimationFrame(updateWaypointClasses);
        }
        function init() {
            $items.addClass(settings.rootClass);
            $items.each(function () {
                var $this = $(this);
                if ($this.data('waypoint')) {
                    $this.data('waypoint', parseFloat($this.data('waypoint')));
                } else {
                    $this.data('waypoint', settings.threshold);
                }
                if ($this.data('waypointDelay')) {
                    $this.data('waypointDelay', parseFloat($this.data('waypointDelay')));
                } else {
                    $this.data('waypointDelay', settings.delay);
                }
            });
            this.enable();
        }
        this.enable = function()
        {
            enableRefresh();
            $(window).on('scroll.waypoint scroll resize orientationchange', enableRefresh);
            requestAnimationFrame(updateWaypointClasses);
        };
        this.disable = function ()
        {
            $(window).off('scroll.waypoint scroll resize orientationchange', enableRefresh);
            cancelAnimationFrame(updateWaypointClasses);
        };
    
        this.destroy = function ()
        {
            disable();
            $items.removeClass(settings.rootClass+' '+ settings.appearClass+ ' '+settings.visibleClass);
            $(this).data(['waypointInstance', 'waypointUpdate', 'waypointVisible', 'waypoint', 'waypointDelay']);
        };
        init.call(this);
        
        return this;
    };

    $.fn.waypoint = function (option) {
        
        if (typeof option === 'string') {
            switch (option) {
                case 'destroy':
                    $(this).data('waypointInstance').destroy();
                    return;
                case 'disable':
                    $(this).data('waypointInstance').disable();
                    return;
                case 'enable':
                    $(this).data('waypointInstance').enable();
                    return;
            }
        }
        
        var settings = $.extend($.fn.waypoint.defaults, option);
        
        $(this).data('waypointInstance', new WaypointInstance(this, settings));

        return this;
    };
    $.fn.waypoint.defaults = {
        delay: 0,
        threshold: 20,
        rootClass: 'Waypoint',
        appearClass: 'waypoint-appear',
        visibleClass: 'waypoint-visible'        
    };

})(jQuery, window);